import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DURATION_2, DURATION_3, EASING_FUNCTION_1, EASING_FUNCTION_2, FADE_IN, FADE_OUT, SLIDE_DOWN_IN20, SLIDE_DOWN_OUT20, SLIDE_LEFT_IN20, SLIDE_RIGHT_IN20, SLIDE_UP_IN20, SLIDE_UP_OUT20, TRANSITION_ROW_DISAPPEARANCE } from '../../utils';
import { AnimationDirection } from '../Calendar/Calendar.types';
import { weekCornersClassNames } from './useWeekCornerStyles.styles';
import { createFocusOutlineStyle } from '@fluentui/react-tabster';
/**
 * @internal
 */
export const calendarDayGridClassNames = {
  wrapper: 'fui-CalendarDayGrid__wrapper',
  table: 'fui-CalendarDayGrid__table',
  dayCell: 'fui-CalendarDayGrid__dayCell',
  daySelected: 'fui-CalendarDayGrid__daySelected',
  daySingleSelected: 'fui-CalendarDayGrid__daySingleSelected',
  weekRow: 'fui-CalendarDayGrid__weekRow',
  weekDayLabelCell: 'fui-CalendarDayGrid__weekDayLabelCell',
  weekNumberCell: 'fui-CalendarDayGrid__weekNumberCell',
  dayOutsideBounds: 'fui-CalendarDayGrid__dayOutsideBounds',
  dayOutsideNavigatedMonth: 'fui-CalendarDayGrid__dayOutsideNavigatedMonth',
  dayButton: 'fui-CalendarDayGrid__dayButton',
  dayIsToday: 'fui-CalendarDayGrid__dayIsToday',
  firstTransitionWeek: 'fui-CalendarDayGrid__firstTransitionWeek',
  lastTransitionWeek: 'fui-CalendarDayGrid__lastTransitionWeek',
  dayMarker: 'fui-CalendarDayGrid__dayMarker',
  dayTodayMarker: 'fui-CalendarDayGrid__dayTodayMarker'
};
/**
 * @internal
 */
export const extraCalendarDayGridClassNames = {
  hoverStyle: 'fui-CalendarDayGrid__hoverStyle',
  pressedStyle: 'fui-CalendarDayGrid__pressedStyle'
};
const useWrapperStyles = /*#__PURE__*/__styles({
  base: {
    Byoj8tv: "f1fow5ox"
  }
}, {
  d: [".f1fow5ox{padding-bottom:10px;}"]
});
const useTableStyles = /*#__PURE__*/__styles({
  base: {
    po53p8: "fgkb47j",
    Bxjg3zr: "f16vktn6",
    Be2twd7: "fjoy568",
    B6of3ja: "fvjh0tl",
    Byoj8tv: "f1fow5ox",
    qhf8xq: "f10pi13n",
    B73mfa3: "f14m3nip",
    fsow6f: "f17mccla",
    a9b677: "f4m2ahc"
  },
  showWeekNumbers: {
    a9b677: "fl524qk"
  }
}, {
  d: [".fgkb47j{border-collapse:collapse;}", ".f16vktn6{border-spacing:0;}", ".fjoy568{font-size:inherit;}", ".fvjh0tl{margin-top:4px;}", ".f1fow5ox{padding-bottom:10px;}", ".f10pi13n{position:relative;}", ".f14m3nip{table-layout:fixed;}", ".f17mccla{text-align:center;}", ".f4m2ahc{width:196px;}", ".fl524qk{width:226px;}"]
});
const useDayCellStyles = /*#__PURE__*/__styles({
  base: {
    sj55zd: "f19n0e5",
    Bceei9c: "f1k6fduh",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1s184ao",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fqtknz5",
    qhf8xq: "f10pi13n",
    Bsw6fvg: "f8pusc0",
    Bbusuzp: "fqgauei",
    cvlxnx: "fp6dsbd",
    Bweudez: "f4xgodq",
    Bsnevi5: 0,
    z1p9vi: 0,
    dua3dm: 0,
    Bf7el8m: "f1ko8o2g",
    xnb59o: "fts5qqo",
    B0mcfed: "fq2wdp5",
    Bj67fi1: "f1lhgsq9",
    B2gfgcj: "fdbuq6n",
    B6cqqer: "f16j2ub3",
    fpurfy: "f5hk6jp",
    Fioj4w: ["f1d258es", "f1llk4aj"],
    Bq9yiu4: "ftezgwa",
    cpbo2x: ["f1llk4aj", "f1d258es"],
    Bq268z6: "f1iohfpm"
  },
  focusIndicator: {
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    B8q5s1w: "f8hki3x",
    Bci5o5g: ["f1d2448m", "ffh67wi"],
    n8qw10: "f1bjia2o",
    Bdrgwmp: ["ffh67wi", "f1d2448m"],
    Bb7d1vk: "f226i61",
    zhwhgb: ["f13kzufm", "fsx75g8"],
    dhy2o1: "flujwa2",
    Gfyso: ["fsx75g8", "f13kzufm"],
    Bm4h7ae: "f15bsgw9",
    B7ys5i9: "f14e48fq",
    Busjfv9: "f18yb2kv",
    Bhk32uz: "fd6o370",
    f6g5ot: 0,
    Boxcth7: 0,
    Bhdgwq3: 0,
    hgwjuy: 0,
    Bshpdp8: 0,
    Bsom6fd: 0,
    Blkhhs4: 0,
    Bonggc9: 0,
    Ddfuxk: 0,
    i03rao: 0,
    kclons: 0,
    clg4pj: 0,
    Bpqj9nj: 0,
    B6dhp37: 0,
    Bf4ptjt: 0,
    Bqtpl0w: 0,
    i4rwgc: "fpqizxz",
    Dah5zi: 0,
    B1tsrr9: 0,
    qqdqy8: 0,
    Bkh64rk: 0,
    e3fwne: "f3znvyf",
    J0r882: "fqkqgbk",
    Bule8hv: ["f1as04kd", "ft30ozv"],
    Bjwuhne: "f8pxvb2",
    Ghsupd: ["ft30ozv", "f1as04kd"]
  }
}, {
  d: [".f19n0e5{color:var(--colorNeutralForeground1);}", ".f1k6fduh{cursor:pointer;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", [".f1s184ao{margin:0;}", {
    p: -1
  }], [".fqtknz5{padding:2px;}", {
    p: -1
  }], ".f10pi13n{position:relative;}", ".fp6dsbd.fui-CalendarDayGrid__hoverStyle{color:var(--colorNeutralForeground1Static);}", ".f4xgodq.fui-CalendarDayGrid__hoverStyle{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f1lhgsq9.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForeground1Static);}", ".fdbuq6n.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", [".fpqizxz[data-fui-focus-visible]::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}", {
    p: -2
  }], [".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".fqkqgbk[data-fui-focus-visible]::after{top:calc(var(--strokeWidthThick) * -1);}", ".f1as04kd[data-fui-focus-visible]::after{right:calc(var(--strokeWidthThick) * -1);}", ".ft30ozv[data-fui-focus-visible]::after{left:calc(var(--strokeWidthThick) * -1);}", ".f8pxvb2[data-fui-focus-visible]::after{bottom:calc(var(--strokeWidthThick) * -1);}"],
  m: [["@media (forced-colors: active){.f8pusc0{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fqgauei{color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ko8o2g.fui-CalendarDayGrid__hoverStyle{outline:1px solid Highlight;}}", {
    p: -1,
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fts5qqo.fui-CalendarDayGrid__hoverStyle{z-index:3;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fq2wdp5.fui-CalendarDayGrid__hoverStyle .fui-CalendarDayGrid__dayTodayMarker{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f16j2ub3.fui-CalendarDayGrid__pressedStyle{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f5hk6jp.fui-CalendarDayGrid__pressedStyle{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1d258es.fui-CalendarDayGrid__pressedStyle{border-right-color:Highlight;}.f1llk4aj.fui-CalendarDayGrid__pressedStyle{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ftezgwa.fui-CalendarDayGrid__pressedStyle{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1iohfpm.fui-CalendarDayGrid__pressedStyle{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f226i61[data-fui-focus-visible]::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f13kzufm[data-fui-focus-visible]::after{border-right-color:Highlight;}.fsx75g8[data-fui-focus-visible]::after{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.flujwa2[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }]],
  f: [".ftqa4ok:focus{outline-style:none;}"],
  i: [".f2hkw1w:focus-visible{outline-style:none;}"]
});
const useDaySelectedStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1vevd59",
    sj55zd: "ff5vbop",
    Bsw6fvg: "f1rirnrt",
    Bjwas2f: "f132fbg1",
    Bn1d65q: ["f1ene5x0", "fzbc999"],
    Bxeuatn: "f6jgcol",
    n51gp8: ["fzbc999", "f1ene5x0"],
    Bbusuzp: "f1lkg8j3",
    ycbfsm: "fkc42ay",
    a3nq4f: "f1chdfq9",
    Bnf3alp: "fq0dbue",
    H2c3sd: "f3pe0v7",
    qu8ld: "f3t0uu2",
    E9zv3o: "ft4goo8"
  }
}, {
  d: [".f1vevd59{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".ff5vbop{color:var(--colorNeutralForeground1Static);}"],
  m: [["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f132fbg1{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ene5x0{border-right-color:Highlight;}.fzbc999{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f6jgcol{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f3pe0v7:hover,.f3pe0v7.fui-CalendarDayGrid__hoverStyle,.f3pe0v7.fui-CalendarDayGrid__pressedStyle{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f3t0uu2:hover,.f3t0uu2.fui-CalendarDayGrid__hoverStyle,.f3t0uu2.fui-CalendarDayGrid__pressedStyle{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ft4goo8>.fui-CalendarDayGrid__dayMarker{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".f1chdfq9:hover,.f1chdfq9.fui-CalendarDayGrid__hoverStyle,.f1chdfq9.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForeground1Static);}", ".fq0dbue:hover,.fq0dbue.fui-CalendarDayGrid__hoverStyle,.fq0dbue.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorBrandBackgroundInvertedSelected);}"]
});
const useDaySingleSelectedStyles = /*#__PURE__*/__styles({
  base: {
    sj55zd: "ff5vbop",
    E9zv3o: "ft4goo8",
    B2ns3jv: "fy35frb",
    Bwxf4zv: 0,
    Bp8cau8: 0,
    Buy161k: 0,
    Bpzqh5e: 0,
    Fh6yq5: "f8kna22",
    B75pphk: "f3ef5pp",
    Cmeexk: ["f1lmnm0c", "f1nrej41"],
    yen2pv: "f1pt3b1q",
    ydc5we: ["f1nrej41", "f1lmnm0c"],
    Bz06psx: "fcydihv",
    Bvql7r5: ["fgb2y1b", "fzbode6"],
    k24jl4: "fofq8g1",
    Bksmc0g: ["fzbode6", "fgb2y1b"],
    Buxuwzc: "f36ub4m",
    xn840g: ["f19aczhj", "ffhc5ea"],
    Jh9m0u: "flfq9gv",
    Fmkg4n: ["ffhc5ea", "f19aczhj"],
    kmtgwu: "fv38a4k",
    g6m10a: "f1wil596",
    Birdjzs: ["f1941p3i", "fsfopon"],
    yojo9v: "f14tb4e3",
    qdeutu: ["fsfopon", "f1941p3i"],
    yfp87c: "f161hy0n",
    zuskld: "fbp2bxz"
  }
}, {
  d: [".ff5vbop{color:var(--colorNeutralForeground1Static);}", ".fy35frb>.fui-CalendarDayGrid__dayButton{background-color:var(--colorBrandBackgroundInvertedSelected);}", [".f8kna22>.fui-CalendarDayGrid__dayButton{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f3ef5pp>.fui-CalendarDayGrid__dayButton{border-top-width:1px;}", ".f1lmnm0c>.fui-CalendarDayGrid__dayButton{border-right-width:1px;}", ".f1nrej41>.fui-CalendarDayGrid__dayButton{border-left-width:1px;}", ".f1pt3b1q>.fui-CalendarDayGrid__dayButton{border-bottom-width:1px;}", ".fcydihv>.fui-CalendarDayGrid__dayButton{border-top-style:solid;}", ".fgb2y1b>.fui-CalendarDayGrid__dayButton{border-right-style:solid;}", ".fzbode6>.fui-CalendarDayGrid__dayButton{border-left-style:solid;}", ".fofq8g1>.fui-CalendarDayGrid__dayButton{border-bottom-style:solid;}", ".f36ub4m>.fui-CalendarDayGrid__dayButton{border-top-color:var(--colorBrandStroke1);}", ".f19aczhj>.fui-CalendarDayGrid__dayButton{border-right-color:var(--colorBrandStroke1);}", ".ffhc5ea>.fui-CalendarDayGrid__dayButton{border-left-color:var(--colorBrandStroke1);}", ".flfq9gv>.fui-CalendarDayGrid__dayButton{border-bottom-color:var(--colorBrandStroke1);}"],
  m: [["@media (forced-colors: active){.ft4goo8>.fui-CalendarDayGrid__dayMarker{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fv38a4k>.fui-CalendarDayGrid__dayButton{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1wil596>.fui-CalendarDayGrid__dayButton{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1941p3i>.fui-CalendarDayGrid__dayButton{border-right-color:Highlight;}.fsfopon>.fui-CalendarDayGrid__dayButton{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f14tb4e3>.fui-CalendarDayGrid__dayButton{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f161hy0n>.fui-CalendarDayGrid__dayButton{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fbp2bxz>.fui-CalendarDayGrid__dayButton{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useWeekRowStyles = /*#__PURE__*/__styles({
  base: {
    qhf8xq: "f10pi13n",
    mlyf9c: "f1gazwyt"
  },
  animation: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Ezkn3b: "f1ee2ue"
  },
  horizontalBackward: {
    Bv12yb3: ["f1o9w3l8", "f1kwjajc"]
  },
  horizontalForward: {
    Bv12yb3: ["f1kwjajc", "f1o9w3l8"]
  },
  verticalBackward: {
    Bv12yb3: "fgl3yn7"
  },
  verticalForward: {
    Bv12yb3: "faiu5ye"
  }
}, {
  d: [".f10pi13n{position:relative;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}", ".f1o9w3l8{animation-name:f5j8bii,f2lgmc3;}", ".f1kwjajc{animation-name:f5j8bii,fpktcv7;}", ".fgl3yn7{animation-name:f5j8bii,f3bv9km;}", ".faiu5ye{animation-name:f5j8bii,funtx0y;}"],
  w: [".f1gazwyt:focus-within{z-index:1;}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}", "@keyframes f2lgmc3{from{pointer-events:none;transform:translate3d(-20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes fpktcv7{from{pointer-events:none;transform:translate3d(20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes f3bv9km{from{pointer-events:none;transform:translate3d(0, -20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes funtx0y{from{pointer-events:none;transform:translate3d(0, 20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}"]
});
const useWeekDayLabelCellStyles = /*#__PURE__*/__styles({
  base: {
    famaaq: "f1xqy1su",
    vin17d: "fhsqnsn",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h7u52p",
    Ezkn3b: "fjq4c94"
  }
}, {
  d: [".f1xqy1su{-webkit-user-select:none;-moz-user-select:none;user-select:none;}", ".fhsqnsn{animation-duration:0.267s;}", ".fywypte{animation-fill-mode:both;}", ".f1h7u52p{animation-name:f5j8bii;}", ".fjq4c94{animation-timing-function:cubic-bezier(.1,.25,.75,.9);}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}"]
});
const useWeekNumberCellStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    u1mtju: ["fe2nn5g", "f1rcbay7"],
    B7ck84d: "f1ewtqcl",
    sj55zd: "fxc4j92",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bqenvij: "fxldao9",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1s184ao",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    a9b677: "f1w9dchk"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", [".fe2nn5g{border-right:1px solid var(--colorNeutralStroke2);}", {
    p: -1
  }], [".f1rcbay7{border-left:1px solid var(--colorNeutralStroke2);}", {
    p: -1
  }], ".f1ewtqcl{box-sizing:border-box;}", ".fxc4j92{color:var(--colorNeutralForeground4);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fxldao9{height:28px;}", [".f1s184ao{margin:0;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".f1w9dchk{width:28px;}"]
});
const useDayOutsideBoundsStyles = /*#__PURE__*/__styles({
  base: {
    x734em: "f1v4z6xg",
    B0ssf13: "f1u9q7oh",
    B8h8h5z: "f1a22lcc",
    Bbusuzp: "f1dcs8yz"
  }
}, {
  d: [".f1v4z6xg,.f1v4z6xg:disabled,.f1v4z6xg button,.f1v4z6xg.fui-CalendarDayGrid__hoverStyle,.f1v4z6xg.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorTransparentBackground);}", ".f1u9q7oh,.f1u9q7oh:disabled,.f1u9q7oh button,.f1u9q7oh.fui-CalendarDayGrid__hoverStyle,.f1u9q7oh.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForegroundDisabled);}", ".f1a22lcc,.f1a22lcc:disabled,.f1a22lcc button,.f1a22lcc.fui-CalendarDayGrid__hoverStyle,.f1a22lcc.fui-CalendarDayGrid__pressedStyle{pointer-events:none;}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDayOutsideNavigatedMonthStyles = /*#__PURE__*/__styles({
  lightenDaysOutsideNavigatedMonth: {
    sj55zd: "fxc4j92",
    Bhrd7zp: "figsok6",
    Bbusuzp: "f1dcs8yz"
  }
}, {
  d: [".fxc4j92{color:var(--colorNeutralForeground4);}", ".figsok6{font-weight:var(--fontWeightRegular);}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDayButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f3bhgqh",
    sj55zd: "f1ym3bx4",
    Bceei9c: "f1k6fduh",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "ff5ikls",
    Bqenvij: "frvgh55",
    Bg96gwp: "f8xlz6g",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    a9b677: "fq4mcun",
    Bx0yju7: "f10y451g",
    l98f4w: "f1dwpgx3",
    Jwef8y: "f18a0fwf",
    Btmb5he: 0,
    gu71dq: 0,
    B2zomw9: 0,
    Fgk69s: 0,
    Bw6eyry: "f1mhq3ai",
    ecr2s2: "f7la2e8"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", [".f3bhgqh{border:none;}", {
    p: -2
  }], ".f1ym3bx4{color:inherit;}", ".f1k6fduh{cursor:pointer;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".ff5ikls{font-weight:inherit;}", ".frvgh55{height:24px;}", ".f8xlz6g{line-height:24px;}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".fq4mcun{width:24px;}", ".f10y451gspan{height:inherit;}", ".f1dwpgx3span{line-height:inherit;}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", [".f1mhq3ai:hover{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }]],
  a: [".f7la2e8:active{background-color:var(--colorBrandBackgroundInvertedPressed);}"]
});
const useDayIsTodayStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    Brf1p80: "f4d9j23",
    Bt984gj: "f122n59",
    sj55zd: "f1phragk",
    Bhrd7zp: "fl43uef",
    kof2un: "f1b5s8wn",
    E9zv3o: "ft4goo8"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f4d9j23{justify-content:center;}", ".f122n59{align-items:center;}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1b5s8wn>.fui-CalendarDayGrid__dayMarker{background-color:var(--colorNeutralForegroundOnBrand);}"],
  m: [["@media (forced-colors: active){.ft4goo8>.fui-CalendarDayGrid__dayMarker{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDayTodayMarkerStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw",
    Brf1p80: "f4d9j23",
    Bt984gj: "f122n59",
    De3pzq: "ffp7eso",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1qtlz2s",
    a9b677: "f64fuq3",
    Bqenvij: "fjamq6b",
    Bg96gwp: "f1n95isl",
    Bsw6fvg: "fg374yq",
    Bjwas2f: "fx4t0an",
    Bn1d65q: ["f1bd7qk0", "fk5vpic"],
    Bxeuatn: "fgxnpfp",
    n51gp8: ["fk5vpic", "f1bd7qk0"],
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f4d9j23{justify-content:center;}", ".f122n59{align-items:center;}", ".ffp7eso{background-color:var(--colorBrandBackground);}", [".f1qtlz2s{border-radius:100%;}", {
    p: -1
  }], ".f64fuq3{width:20px;}", ".fjamq6b{height:20px;}", ".f1n95isl{line-height:20px;}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fx4t0an{border-top-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1bd7qk0{border-right-color:WindowText;}.fk5vpic{border-left-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fgxnpfp{border-bottom-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useFirstTransitionWeekStyles = /*#__PURE__*/__styles({
  base: {
    Bqenvij: "fniina8",
    abs64n: "fk73vx1",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    qhf8xq: "f1euv43f",
    a9b677: "f3tsq5r"
  },
  verticalForward: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Bv12yb3: "fupj2f5",
    Ezkn3b: "f1ee2ue"
  }
}, {
  d: [".fniina8{height:0;}", ".fk73vx1{opacity:0;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], ".f1euv43f{position:absolute;}", ".f3tsq5r{width:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".fupj2f5{animation-name:f199e34v,f76svrd,f13agkrc;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}"],
  k: ["@keyframes f199e34v{from{opacity:1;}to{opacity:0;visibility:hidden;}}", "@keyframes f76svrd{from{transform:translate3d(0, 0, 0);}to{transform:translate3d(0, -20px, 0);}}", "@keyframes f13agkrc{100%{height:0px;overflow:hidden;width:0px;}99.9%{height:28px;overflow:visible;width:100%;}0%{height:28px;overflow:visible;width:100%;}}"]
});
const useLastTransitionWeekStyles = /*#__PURE__*/__styles({
  base: {
    Bqenvij: "fniina8",
    B6of3ja: "flykjtj",
    abs64n: "fk73vx1",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    qhf8xq: "f1euv43f",
    a9b677: "f3tsq5r"
  },
  verticalBackward: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Bv12yb3: "fifoktk",
    Ezkn3b: "f1ee2ue"
  }
}, {
  d: [".fniina8{height:0;}", ".flykjtj{margin-top:-28px;}", ".fk73vx1{opacity:0;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], ".f1euv43f{position:absolute;}", ".f3tsq5r{width:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".fifoktk{animation-name:f199e34v,f18895iq,f13agkrc;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}"],
  k: ["@keyframes f199e34v{from{opacity:1;}to{opacity:0;visibility:hidden;}}", "@keyframes f18895iq{from{transform:translate3d(0, 0, 0);}to{transform:translate3d(0, 20px, 0);}}", "@keyframes f13agkrc{100%{height:0px;overflow:hidden;width:0px;}99.9%{height:28px;overflow:visible;width:100%;}0%{height:28px;overflow:visible;width:100%;}}"]
});
const useDayMarkerStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "fnggedw",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1qtlz2s",
    B5kzvoi: "f1oq0udb",
    Bqenvij: "f6ywr7j",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"],
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "fcpdi13",
    qhf8xq: "f1euv43f",
    j35jbq: ["f1e31b4d", "f1vgc2s3"],
    a9b677: "faro0ui",
    Bsw6fvg: "fg374yq",
    ycbfsm: "fkc42ay"
  }
}, {
  d: [".fnggedw{background-color:var(--colorBrandForeground2);}", [".f1qtlz2s{border-radius:100%;}", {
    p: -1
  }], ".f1oq0udb{bottom:1px;}", ".f6ywr7j{height:4px;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", [".fcpdi13{margin:auto;}", {
    p: -1
  }], ".f1euv43f{position:absolute;}", ".faro0ui{width:4px;}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useCornerBorderAndRadiusStyles = /*#__PURE__*/__styles({
  corners: {
    Cy64m2: ["f1yxjewa", "f5xfyye"],
    Bnn43bw: ["f1kpdnd7", "fokqrni"],
    feanbc: ["f127emps", "f1s6s1el"],
    B4268ip: ["f39vr2a", "frpqyrn"]
  }
}, {
  d: [".f1yxjewa.fui-CalendarDayGrid__topRightCornerDate{border-top-right-radius:var(--borderRadiusMedium);}", ".f5xfyye.fui-CalendarDayGrid__topRightCornerDate{border-top-left-radius:var(--borderRadiusMedium);}", ".f1kpdnd7.fui-CalendarDayGrid__topLeftCornerDate{border-top-left-radius:var(--borderRadiusMedium);}", ".fokqrni.fui-CalendarDayGrid__topLeftCornerDate{border-top-right-radius:var(--borderRadiusMedium);}", ".f127emps.fui-CalendarDayGrid__bottomRightCornerDate{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f1s6s1el.fui-CalendarDayGrid__bottomRightCornerDate{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f39vr2a.fui-CalendarDayGrid__bottomLeftCornerDate{border-bottom-left-radius:var(--borderRadiusMedium);}", ".frpqyrn.fui-CalendarDayGrid__bottomLeftCornerDate{border-bottom-right-radius:var(--borderRadiusMedium);}"]
});
/**
 * @internal
 *
 * Apply styling to the CalendarDayGrid slots based on the state
 */
export const useCalendarDayGridStyles_unstable = props => {
  'use no memo';

  const wrapperStyles = useWrapperStyles();
  const tableStyles = useTableStyles();
  const dayCellStyles = useDayCellStyles();
  const daySelectedStyles = useDaySelectedStyles();
  const daySingleSelectedStyles = useDaySingleSelectedStyles();
  const weekRowStyles = useWeekRowStyles();
  const weekDayLabelCellStyles = useWeekDayLabelCellStyles();
  const weekNumberCellStyles = useWeekNumberCellStyles();
  const dayOutsideBoundsStyles = useDayOutsideBoundsStyles();
  const dayOutsideNavigatedMonthStyles = useDayOutsideNavigatedMonthStyles();
  const dayButtonStyles = useDayButtonStyles();
  const dayIsTodayStyles = useDayIsTodayStyles();
  const firstTransitionWeekStyles = useFirstTransitionWeekStyles();
  const lastTransitionWeekStyles = useLastTransitionWeekStyles();
  const dayMarkerStyles = useDayMarkerStyles();
  const cornerBorderAndRadiusStyles = useCornerBorderAndRadiusStyles();
  const dayTodayMarkerStyles = useDayTodayMarkerStyles();
  const {
    animateBackwards,
    animationDirection,
    lightenDaysOutsideNavigatedMonth,
    showWeekNumbers
  } = props;
  return {
    wrapper: mergeClasses(calendarDayGridClassNames.wrapper, wrapperStyles.base),
    table: mergeClasses(calendarDayGridClassNames.table, tableStyles.base, showWeekNumbers && tableStyles.showWeekNumbers),
    dayCell: mergeClasses(calendarDayGridClassNames.dayCell, dayCellStyles.base, dayCellStyles.focusIndicator, cornerBorderAndRadiusStyles.corners),
    daySelected: mergeClasses(calendarDayGridClassNames.daySelected, daySelectedStyles.base),
    daySingleSelected: mergeClasses(calendarDayGridClassNames.daySingleSelected, daySingleSelectedStyles.base),
    weekRow: mergeClasses(calendarDayGridClassNames.weekRow, weekRowStyles.base, animateBackwards !== undefined && weekRowStyles.animation, animateBackwards !== undefined && (animationDirection === AnimationDirection.Horizontal ? animateBackwards ? weekRowStyles.horizontalBackward : weekRowStyles.horizontalForward : animateBackwards ? weekRowStyles.verticalBackward : weekRowStyles.verticalForward)),
    weekDayLabelCell: mergeClasses(calendarDayGridClassNames.weekDayLabelCell, weekDayLabelCellStyles.base),
    weekNumberCell: mergeClasses(calendarDayGridClassNames.weekNumberCell, weekNumberCellStyles.base),
    dayOutsideBounds: mergeClasses(calendarDayGridClassNames.dayOutsideBounds, dayOutsideBoundsStyles.base),
    dayOutsideNavigatedMonth: mergeClasses(calendarDayGridClassNames.dayOutsideNavigatedMonth, lightenDaysOutsideNavigatedMonth && dayOutsideNavigatedMonthStyles.lightenDaysOutsideNavigatedMonth),
    dayButton: mergeClasses(calendarDayGridClassNames.dayButton, dayButtonStyles.base),
    dayIsToday: mergeClasses(calendarDayGridClassNames.dayIsToday, dayIsTodayStyles.base),
    firstTransitionWeek: mergeClasses(calendarDayGridClassNames.firstTransitionWeek, firstTransitionWeekStyles.base, animateBackwards !== undefined && animationDirection !== AnimationDirection.Horizontal && !animateBackwards && firstTransitionWeekStyles.verticalForward),
    lastTransitionWeek: mergeClasses(calendarDayGridClassNames.lastTransitionWeek, lastTransitionWeekStyles.base, animateBackwards !== undefined && animationDirection !== AnimationDirection.Horizontal && animateBackwards && lastTransitionWeekStyles.verticalBackward),
    dayMarker: mergeClasses(calendarDayGridClassNames.dayMarker, dayMarkerStyles.base),
    dayTodayMarker: mergeClasses(calendarDayGridClassNames.dayTodayMarker, dayTodayMarkerStyles.base)
  };
};